import { LoadingOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";

interface IProps {
  loading?: boolean;
  fullscreen?: boolean;
  children?: React.ReactNode;
}

export const SharedSpinner: React.FC<IProps> = ({
  loading,
  fullscreen,
  children,
}) => {
  const { t } = useTranslation();
  return (
    <Spin
      spinning={loading}
      description={children ? t("LoadingTip") : undefined}
      fullscreen={fullscreen}
      indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
    >
      {children}
    </Spin>
  );
};
